import { createContext, useContext, useState } from 'react';
import { AppContext } from './AppContext';
import RouterPrompt from './components/RouterPrompt';
import useRouter from './hooks/useRouter';
import { AppActionType, AppContextType } from './types/appContext.type';

type RoutePromptContextProps = {
  isDirty: boolean;
  setIsDirty: (value: boolean) => void;
  handleNavigationAttempt: (path: string, isDirty: boolean) => void;
};

export const RoutePromptContext = createContext<RoutePromptContextProps | null>(
  null,
);

export const RoutePromptProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isDirty, setIsDirty] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [pendingNavigation, setPendingNavigation] = useState<string | null>(
    null,
  );
  const { navigate } = useRouter();
  const { dispatch } = useContext(AppContext) as AppContextType;

  // Confirm navigation
  const confirmNavigation = () => {
    setShowModal(false);
    dispatch({
      type: AppActionType.setRouterPrompt,
      data: false,
    });

    if (pendingNavigation) {
      navigate(pendingNavigation);
      setPendingNavigation(null);
    }
  };

  // Handle navigation attempt
  const handleNavigationAttempt = (path: string, isDirty: boolean) => {
    if (isDirty) {
      setPendingNavigation(path);
      setShowModal(true);
    } else {
      navigate(path);
    }
  };

  return (
    <RoutePromptContext.Provider
      value={{ isDirty, setIsDirty, handleNavigationAttempt }}
    >
      {children}

      {/* Confirmation Modal */}
      <RouterPrompt
        isPrompt={showModal}
        handleOK={confirmNavigation}
        handleCancel={() => setShowModal(false)}
      />
    </RoutePromptContext.Provider>
  );
};
